(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers-openings"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('careers-board')) {
    customElements.define(
      'careers-board',
      class extends HTMLElement {
        connectedCallback() {
          this.buttons = [...this.querySelectorAll('[data-filter]')];
          this.groups = [...this.querySelectorAll('[data-department]')];
          this.status = this.querySelector('[data-careers-status]');
          this.buttons.forEach((button) => button.addEventListener('click', () => this.select(button)));
        }

        select(button) {
          const value = button.dataset.filter;
          this.buttons.forEach((b) => b.setAttribute('aria-pressed', String(b === button)));
          let visible = 0;
          this.groups.forEach((group) => {
            const show = value === 'all' || group.dataset.department === value;
            group.hidden = !show;
            if (show) visible += group.querySelectorAll('.careers-card').length;
          });
          if (this.status) {
            const template = visible === 1 ? this.dataset.countOne : this.dataset.countMany;
            if (template) this.status.textContent = template.replace('[count]', visible);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["job-opening"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.job__share');
    if (!button) return;
    const url = button.dataset.shareUrl;
    const label = button.querySelector('[data-share-text]');
    const original = label.textContent;
    const done = () => {
      label.textContent = button.dataset.copiedLabel;
      setTimeout(() => (label.textContent = original), 2500);
    };
    if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      navigator.share({ title: document.title, url }).catch(() => {});
      return;
    }
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(done).catch(() => {});
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
